<template>
  <div class="l_premium_faq">
    <div class="container">
      <div class="content">
        <div v-if="existHeader()" class="header">
          <img
            src="@/assets/img/faq/close_premium.svg"
            @click="closeFAQPremium()"
          />
        </div>
        <h3>プレミアムラウンジって何？</h3>
        <hr />
        <br />
        <p>
          香の川製麺プレミアムラウンジは、1年間で<span>「プラチナカード以上(101スタンプ以上)」</span>を獲得されたお客様が次の1年間、特別に入室できるアプリ内のエリアになります。<br />
          プレミアムラウンジでは、<span>プレミアムラウンジ会員様限定の情報やクーポン・特典</span>などをご用意しています。
        </p>
        <br />
        <img
          class="image"
          style="padding: 0px 10px"
          :src="require('@/assets/img/faq/about_premium_2.png')"
        />
        <br />
        <br />
        <p>
          ※お客様によってプレミアムラウンジが出現するタイミングが異なります。<span>スタンプカード右上の期限内にプラチナカード以上(101スタンプ以上)を獲得されたお客様</span>は、次期限（１年間）が開始したタイミングで、プレミアムラウンジに入室いただけます。
        </p>
        <br />
        <br />
        <br />
        <h3>プレミアムラウンジの有効期間とご利用条件</h3>
        <hr />
        <p>
          香の川製麺プレミアムラウンジに入室できる期間は<span>１年間</span>となります。<br />
          <span
            >次の1年もプレミアムラウンジをご利用いただくには、再度スタンプカードの有効期限内に「プラチナカード以上(101スタンプ以上)」を獲得していただく必要</span
          >がございます。
        </p>
        <br />
        <br />
        <h3>[特典①] プレミアムラウンジ会員限定クーポン</h3>
        <hr />
        <p>
          香の川製麺プレミアムラウンジ会員限定のクーポンを各種ご用意いたします。（期間によって内容が異なります。）
        </p>
        <div class="image">
          <img
            class="image"
            :src="require('@/assets/img/faq/about_premium_6.jpg')"
          />
          <div class="prize1-text">
            <p class="prize1-text2">※画像はイメージです。</p>
          </div>
        </div>
        <p>
          ラウンジクーポン、ラウンジフリーパスはアプリバージョン6.3.0以降、通常クーポンページにも掲載されています。
        </p>
        <br />
        <br />
        <h3>[特典②]前年、ダイヤモンドカード達成のお客様への特別フリーパス</h3>
        <hr />
        <p>
          前年に、ダイヤモンドカードを達成され、「選べる１年間フリーパス」を獲得されたお客様は、次の1年でシルバー・ゴールド・プラチナ・ダイヤモンドカード達成時に、<span>プレミアムラウンジ内でスープバーもご利用頂ける「プレミアムラウンジ限定選べるフリーパス」（期間は各カードによって異なります）を追加で獲得</span>いただくことができます。
        </p>
        <br />
        <img
          class="image"
          style="padding: 0px 10px"
          :src="require('@/assets/img/faq/2308-lounge1.png')"
          alt=""
        />
        <p>
          ラウンジクーポン、ラウンジフリーパスはアプリバージョン6.3.0以降、通常クーポンページにも掲載されています。
        </p>
        <br />
        <br />
        <h3>[特典③] プレミアムラウンジ会員限定のお楽しみ情報配信！</h3>
        <hr />
        <p>
          一足早い新メニュー情報や、香の川製麺トリビアなど、プレミアムラウンジ会員限定の情報も配信いたします。ぜひお楽しみください。<br />
          <br />
          上記の内容は予告なく変更になる場合がございます。あらかじめご了承ください。
        </p>
        <br />
        <br />
        <h3>
          スタンプカードリセット後、プレミアムラウンジを継続できなかったお客様へのご注意
        </h3>
        <hr />
        <p>
          プレミアムラウンジに入室されていたお客様で、次回のスタンプカードリセット時にプレミアムラウンジを継続できなかったお客様は、プレミアムラウンジに入室することができなくなります。<br />
          ただし、スタンプカードリセット前に未使用のラウンジクーポン/フリーパス及び何度でも使用可能なラウンジクーポンで有効期限に達していないクーポンがある場合は、クーポンページにて有効期限まで引き続きお使いいただけます。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'FAQPremium',
  data: function () {
    return {
      showHeaderQueryString: 'showHeader',
      showHeader: 'false'
    }
  },
  created() {
    document.title = '香の川製麺プレミアムラウンジ'
    this.__checkQuery()
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    __checkQuery() {
      this.showHeader = this.$route.query[this.showHeaderQueryString]
    },
    existHeader() {
      return this.showHeader === 'true'
    },
    closeFAQPremium() {
      this.trackEvent(FactoryTrack.createFAQPremiumClose())
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  color: #333333;
}

span {
  font-weight: bold;
}

.l_premium_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_premium_faq h3,
.l_premium_faq h4 {
  color: #602209;
  font-family: 'HiraKakuPro-W6', sans-serif;
}

.l_premium_faq h4 {
  margin: 10px 0px;
}

.l_premium_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}

.l_premium_faq .content hr {
  margin-top: 10px;
  margin-bottom: 10px;
  border: none;
  border-bottom: 1px solid #efb90f;
}

.l_premium_faq .content .image {
  margin-top: 10px;
  margin-bottom: 10px;
  max-width: 100%;
  text-align: center;
}

.l_premium_faq .content .image3 {
  margin-top: 10px;
  margin-bottom: 10px;
  max-width: 80%;
}

.l_premium_faq .content .image4 {
  margin-top: 10px;
  margin-bottom: 10px;
  max-width: 100%;
}

.header {
  padding-bottom: 13px;
  text-align: end;
}

.prize1-text {
  display: inline;
}

.prize1-text2 {
  text-align: end;
}
</style>
